import { render, staticRenderFns } from "./AvatarWithStatus.vue?vue&type=template&id=1721ef3a&scoped=true&"
import script from "./AvatarWithStatus.vue?vue&type=script&lang=ts&"
export * from "./AvatarWithStatus.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarWithStatus.vue?vue&type=style&index=0&id=1721ef3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1721ef3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
installComponents(component, {VImg,VListItemAvatar})
